/**
 * Was machine output asked for, before anything can fail?
 *
 * The failure path needs to know, and it starts in `main()`'s catch — including
 * for errors raised BY the parser, which is exactly when an agent most needs a
 * parseable answer. Mirrors the parser's own rule: a bare `--json` token, and
 * `--` ends option parsing so a prompt may still contain the word.
 */
export function wantsJson(argv: string[]): boolean {
  for (const token of argv) {
    if (token === "--") {
      return false;
    }
    if (token === "--json") {
      return true;
    }
  }
  return false;
}
